import axios from 'axios';

const BASE_URL = 'https://api.bigcommerce.com/stores/YOUR_STORE_HASH/v3';
const ACCESS_TOKEN = 'YOUR_ACCESS_TOKEN';

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'X-Auth-Token': ACCESS_TOKEN,
    'Content-Type': 'application/json'
  }
});

export const getProductData = async (productId) => {
  const response = await api.get(`/catalog/products/${productId}`);
  return response.data.data;
};

export const getProductOptions = async (productId) => {
  const response = await api.get(`/catalog/products/${productId}/options`);
  return response.data.data;
};
